import React from 'react';
import StatusIcon, {StaleSyncWarning} from '../../../components/StatusIcon';
import DiskUsage from '../../../components/DiskUsage';
import MediablockClock from '../../../components/MediablockClock';
import MediablockProperties from '../forms/MediablockProperties';
import SettingsPanel from './SettingsPanel';

// Shared between SystemsTab (BAC staff, editable) and OverviewTab (site users, read-only).
const MediablockPanel = ({ organization, bacView, handleUpdate }) => (
    <SettingsPanel
        icon="fa-database"
        title="Mediablock status"
        toggleLabel={bacView ? 'Edit' : 'Details'}
        summary={
            <>
                <div className="me-3 text-center">
                    <StatusIcon type="mediablockStatus" value={organization.mediablock?.status} showLabel />
                </div>

                {organization.mediablock?.status === 'Connected' && (
                    <div className="me-3 text-center">
                        <span className="fas fa-hard-drive me-2 text-primary"/>
                        <DiskUsage
                            capacity={organization.mediablock?.capacity}
                            usedDiskSpace={organization.mediablock?.usedDiskSpace}
                        />
                    </div>
                )}

                {organization.mediablock?.status === 'Connected' && (
                    <MediablockClock
                        timeZone={organization.mediablock?.timeZone}
                        clockOffsetSeconds={organization.mediablock?.clockOffsetSeconds}
                        timeSource={organization.mediablock?.timeSource}
                        compact
                    />
                )}

                <StaleSyncWarning lastSynced={organization.lastSynced} />
            </>
        }
    >
        <MediablockProperties
            initialSettings={organization.mediablock}
            onSave={handleUpdate('mediablock')}
            bacView={bacView}
        />
    </SettingsPanel>
);

export default MediablockPanel;
